import {WhitelabelConfig} from "./WhitelabelConfig";
import {CompanyEnumIndices} from "@bdswiss/common-enums";

export const skyGround: WhitelabelConfig = {
    whitelabel: CompanyEnumIndices.skyGround,
    domainNames: [
        'skyground.skyground-staging.com',
        'skyground.local'
    ],
}
